import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

let context_path = process.env.VUE_APP_CONTEXT_PATH;

const router= new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      alias: "/home",
      name: "home",
      component: () => import("./views/Home")
    },
    {
      path: "/nothing",
      alias: "/nothing",
      name: "nothing",
      component: () => import("./views/Nothing")
    },
    {
      path: "/user/management",
      name: "roleManagement",
      component: () => import("./views/RoleManagementView")
    } 

  ],
  base: context_path
});

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (router.app.$keycloak.authenticated) {
      next()
    } else {
      const loginUrl = router.app.$keycloak.createLoginUrl()
      window.location.replace(loginUrl)
    }
  } else {
    next()
  }
})

export default router
